import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    PieChartLegendDynamicStyleType
} from "../../type";

const stylesheet = StyleSheet.create({
    container: {
        flexDirection: "column",
        width: "100%"
    },
    column: {
        alignItems: "flex-end"
    },
    row: {
        alignItems: "center",
        flexDirection: "row"
    },
    number: {
        fontVariant: [
            "tabular-nums"
        ]
    },
    label: {
        flexShrink: 1,
        flexGrow: 1
    }
});

export const useStyles = ({
    shareWidth,
    valueWidth,
    radiuses,
    colors,
    spaces
}: PieChartLegendDynamicStyleType) => {
    const styles = {
        activeRow: {
            backgroundColor: colors.system.state.overlay.hover.default
        } as ViewStyle,
        row: {
            paddingHorizontal: spaces.spacingSm,
            paddingVertical: spaces.spacingXs,
            borderRadius: radiuses.xs,
            gap: spaces.spacingSm
        } as ViewStyle,
        share: {
            minWidth: shareWidth
        },
        value: {
            minWidth: valueWidth
        }
    };

    return styles;
};
export default stylesheet;
